export const mapBackendToForm = (data, uhid_no) => {
  if (!data) return null;

  const shiftedDateTime = data.shifted_to_ward_time
    ? new Date(data.shifted_to_ward_time).toISOString().slice(0, 16)
    : "";

  return {
    uhid_no: data.uhid_no || uhid_no,
    ip_no: data.ip_no || "",
    reports: {
      "Lab Reports": { recovery: data.lab_reports_recovery_ot || "", ward: data.lab_reports_ward || "" },
      "X-Ray": { recovery: data.xray_recovery_ot || "", ward: data.xray_ward || "" },
      "Echo/PFT/TMT": { recovery: data.echo_pft_tmt_recovery_ot || "", ward: data.echo_pft_tmt_ward || "" },
      "ECG": { recovery: data.ecg_recovery_ot || "", ward: data.ecg_ward || "" },
      "USG": { recovery: data.usg_recovery_ot || "", ward: data.usg_ward || "" },
      "MRI": { recovery: data.mri_recovery_ot || "", ward: data.mri_ward || "" },
      "Case Sheet/Operative Notes": { recovery: data.case_sheet_notes_recovery_ot || "", ward: data.case_sheet_notes_ward || "" },
      "Others": { recovery: data.others_recovery_ot || "", ward: data.others_ward || "" }
    },
    relatives_name: data.relatives_name || "",
    histopathologySample: data.histopathology_sample_shown ? "Yes" : "No",
    relatives_signature: data.relatives_signature || "",
    shiftedToWard: shiftedDateTime,
    handOverBy: data.handover_by || "",
    takenOverBy: data.takenover_by || "",
    handover_signature: data.handover_signature || "",
  };
};

export const mapFormToBackend = (formData) => {
  const formattedOrderDate = formData.shiftedToWard
    ? new Date(formData.shiftedToWard)
    : new Date();

  const formattedOrderDatetime = formattedOrderDate
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");

  return {
    uhid_no: formData.uhid_no,
    ip_no: formData.ip_no,
    lab_reports_recovery_ot: formData.reports["Lab Reports"].recovery,
    lab_reports_ward: formData.reports["Lab Reports"].ward,
    xray_recovery_ot: formData.reports["X-Ray"].recovery,
    xray_ward: formData.reports["X-Ray"].ward,
    echo_pft_tmt_recovery_ot: formData.reports["Echo/PFT/TMT"].recovery,
    echo_pft_tmt_ward: formData.reports["Echo/PFT/TMT"].ward,
    ecg_recovery_ot: formData.reports["ECG"].recovery,
    ecg_ward: formData.reports["ECG"].ward,
    usg_recovery_ot: formData.reports["USG"].recovery,
    usg_ward: formData.reports["USG"].ward,
    mri_recovery_ot: formData.reports["MRI"].recovery,
    mri_ward: formData.reports["MRI"].ward,
    case_sheet_notes_recovery_ot: formData.reports["Case Sheet/Operative Notes"].recovery,
    case_sheet_notes_ward: formData.reports["Case Sheet/Operative Notes"].ward,
    others_recovery_ot: formData.reports["Others"].recovery,
    others_ward: formData.reports["Others"].ward,
    histopathology_sample_shown: formData.histopathologySample === "Yes" ? 1 : 0,
    relatives_name: formData.relatives_name,
    relatives_signature: formData.relatives_signature,
    shifted_to_ward_time: formattedOrderDatetime,
    handover_by: formData.handOverBy,
    takenover_by: formData.takenOverBy,
    handover_signature: formData.handover_signature,
  };
};
